(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["meta-product-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spottle-bundle-status')) {
  customElements.define('spottle-bundle-status', class extends HTMLElement {
    connectedCallback() {
      this.bundle = this.closest('product-bundle');
      this.button = this.querySelector('button');
      this.count = this.querySelector('[data-bundle-count]');
      this.hint = this.querySelector('[data-bundle-hint]');
      if (!this.bundle || !this.button || !this.count) return;
      this.timers = new Map();
      this.variantPrices = new Map();
      this.priceRenders = new WeakMap();
      this.controller = new AbortController();
      const section = this.bundle.closest('.page-width');
      const intro = section.querySelector('[data-bundle-intro]');
      const mobileSlot = section.querySelector('[data-bundle-intro-mobile]');
      const desktopSlot = section.querySelector('[data-bundle-intro-desktop]');
      if (intro && mobileSlot && desktopSlot) {
        const mobile = matchMedia('(max-width: 1023px)');
        const placeIntro = () => {
          const target = mobile.matches ? mobileSlot : desktopSlot;
          if (intro.parentElement !== target) target.prepend(intro);
        };
        mobile.addEventListener('change', placeIntro, { signal: this.controller.signal });
        placeIntro();
      }
      this.items = this.bundle.querySelector('.product-bundle__body');
      this.scrollHint = this.bundle.querySelector('[data-bundle-scroll-hint]');
      this.items.addEventListener('scroll', () => this.updateScroll(), { passive: true, signal: this.controller.signal });
      this.resizeObserver = new ResizeObserver(() => this.updateScroll());
      this.resizeObserver.observe(this.items);
      this.bundle.addEventListener('bundle:added', event => queueMicrotask(() => {
        const variant = event.detail?.variant;
        if (variant?.id) this.variantPrices.set(String(variant.id), Number(variant.compare_at_price) || 0);
        this.update();
        this.confirmAddition(event);
      }), { signal: this.controller.signal });
      this.bundle.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('[data-product-bundle-variant] input[type="number"]')) {
          const minimum = Number(input.min) || 1;
          const maximum = input.max ? Number(input.max) : Infinity;
          const step = Number(input.step) || 1;
          const value = Number(input.value);
          const bounded = Math.min(maximum, Math.max(minimum, Number.isFinite(value) ? value : minimum));
          const steps = Math.min(Math.floor((maximum - minimum) / step), Math.max(0, Math.round((bounded - minimum) / step)));
          input.value = String(minimum + steps * step);
          input.setCustomValidity('');
        }
        queueMicrotask(() => this.update());
      }, { capture: true, signal: this.controller.signal });
      this.bundle.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.bundle.classList.contains('active') && matchMedia('(max-width: 1023px)').matches) {
          this.bundle.classList.remove('active');
          this.button.focus({ preventScroll: true });
        }
      }, { signal: this.controller.signal });
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.bundle, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-variant-id', 'class']
      });
      this.update();
    }
    update() {
      const count = this.bundle.querySelectorAll('[data-product-bundle-variant][data-variant-id]').length;
      this.bundle.querySelectorAll('[data-product-bundle-variant][data-variant-id]').forEach((row, index) => {
        const title = row.querySelector('.horizontal-product__title')?.textContent.trim() || '';
        const input = row.querySelector('input');
        const label = row.querySelector('label');
        const id = `${this.bundle.id}-quantity-${index}`;
        if (input && input.id !== id) input.id = id;
        if (label && label.htmlFor !== id) label.htmlFor = id;
        row.querySelectorAll('.quantity__button').forEach(button => {
          const template = button.dataset.quantityLabel || button.getAttribute('aria-label');
          if (!button.dataset.quantityLabel) button.dataset.quantityLabel = template;
          const name = template.replace('[product]', title);
          if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label', name);
        });
        const price = row.querySelector('[data-product-bundle-variant-price]');
        if (price && window.theme?.Currency && input) {
          const quantity = Math.max(1, Number(input.value) || 1);
          const unitPrice = Number(price.dataset.price);
          const reference = this.variantPrices.get(row.dataset.variantId) || 0;
          const reduced = reference > unitPrice;
          const moneyFormat = window.theme.settings.currencyCodeEnabled ? window.theme.settings.moneyWithCurrencyFormat : window.theme.settings.moneyFormat;
          const key = `${quantity}:${unitPrice}:${reference}:${moneyFormat}`;
          if (this.priceRenders.get(price) !== key) {
            const format = value => window.theme.Currency.formatMoney(value, moneyFormat);
            const escape = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
            const savings = format((reference - unitPrice) * quantity);
            const each = quantity > 1 ? `<span class="cart-drawer__each-price text-xs text-opacity">${escape(this.dataset.eachLabel).replace('[money]', format(unitPrice))}</span>` : '';
            const badge = reduced ? `<span class="badge badge--onsale cart-drawer__inline-savings flex items-center font-medium">${escape(this.dataset.savingsLabel).replace('[money]', savings)}</span>` : '';
            price.innerHTML = `<div class="price cart-drawer__price${reduced ? ' cart-drawer__price--reduced' : ''} text-sm"><span class="sr-only">${escape(reduced ? this.dataset.saleLabel : this.dataset.regularLabel)}</span><span class="cart-drawer__current-price whitespace-nowrap">${format(unitPrice * quantity)}</span>${reduced ? `<span class="cart-drawer__reference-price text-xs text-opacity whitespace-nowrap"><span class="sr-only">${escape(this.dataset.regularLabel)}</span><s>${format(reference * quantity)}</s></span>` : ''}</div>${each || badge ? `<div class="cart-drawer__price-details">${each}${badge}</div>` : ''}`;
            const savingsBadge = price.querySelector('.cart-drawer__inline-savings');
            if (savingsBadge) {
              const money = document.createElement('span');
              money.innerHTML = savings;
              savingsBadge.setAttribute('aria-label', this.dataset.savingsTotalLabel.replace('[money]', money.textContent));
            }
            this.priceRenders.set(price, key);
          }
        }
        const remove = row.querySelector('.spottle-bundle__remove');
        if (remove) {
          const name = `${remove.textContent.trim()}: ${title}`;
          if (remove.getAttribute('aria-label') !== name) remove.setAttribute('aria-label', name);
        }
        const image = row.querySelector('img');
        if (image && !image.hasAttribute('alt')) image.alt = '';
      });
      this.updateScroll();
      const minimum = Number(this.bundle.dataset.minimum);
      const text = count < minimum ? `${count} / ${minimum}` : this.dataset.countLabel.replace('[count]', count);
      if (this.count.textContent !== text) this.count.textContent = text;
      const hint = count < minimum ? this.dataset.missingLabel.replace('[count]', minimum - count) : this.dataset.reviewLabel;
      if (this.hint.textContent !== hint) this.hint.textContent = hint;
      this.bundle.querySelector('[data-bundle-empty]').hidden = count > 0;
      this.button.setAttribute('aria-expanded', String(this.bundle.classList.contains('active')));
    }
    updateScroll() {
      const overflow = this.items.scrollHeight > this.items.clientHeight + 2;
      this.scrollHint.toggleAttribute('data-overflow', overflow);
      this.scrollHint.toggleAttribute('data-end', this.items.scrollTop + this.items.clientHeight >= this.items.scrollHeight - 3);
    }
    confirmAddition(event) {
      const card = event.detail?.product;
      const variantId = String(event.detail?.variant?.id);
      if (!card || !Array.from(this.bundle.querySelectorAll('[data-variant-id]')).some(row => row.dataset.variantId === variantId)) return;
      const text = card.querySelector('.product-form__submit .btn-text');
      if (!text) return;
      const previous = this.timers.get(card);
      if (previous) clearTimeout(previous.timer);
      const original = previous?.original ?? text.textContent;
      text.textContent = this.dataset.addedLabel;
      card.setAttribute('data-bundle-added', '');
      const announcement = this.bundle.querySelector('[data-bundle-announcement]');
      announcement.textContent = `${card.querySelector('[data-product-bundle-title]').textContent.trim()}: ${this.dataset.addedLabel}`;
      const timer = setTimeout(() => {
        if (text.isConnected && text.textContent === this.dataset.addedLabel) text.textContent = original;
        card.removeAttribute('data-bundle-added');
        this.timers.delete(card);
      }, 1800);
      this.timers.set(card, { timer, original });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.timers?.forEach(({ timer }) => clearTimeout(timer));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-shop-the-feed"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('spottle-feed-video')) return;

  const players = new Set();
  let owner = null;

  class SpottleFeedVideo extends HTMLElement {
    connectedCallback() {
      if (this._events) return;

      this._video = this.querySelector('video');
      this._button = this.querySelector('[data-feed-play]');
      this._controls = this.querySelector('[data-feed-controls]');
      this._toggle = this.querySelector('[data-feed-toggle]');
      this._mute = this.querySelector('[data-feed-mute]');
      this._fullscreen = this.querySelector('[data-feed-fullscreen]');
      this._seek = this.querySelector('[data-feed-seek]');
      this._current = this.querySelector('[data-feed-current]');
      this._duration = this.querySelector('[data-feed-duration]');
      if (![this._video, this._button, this._controls, this._toggle, this._mute,
        this._fullscreen, this._seek, this._current, this._duration].every(Boolean)) return;

      this._events = new AbortController();
      const options = { signal: this._events.signal };
      this._playLabel = this.dataset.playLabel || this._button.getAttribute('aria-label') || '';
      this._pending = null;
      this._keyboardMode = false;
      this._keyboardFocus = false;
      this._seeking = false;
      this._webkitFullscreen = false;
      this._video.autoplay = false;
      this._video.removeAttribute('autoplay');
      this._video.loop = this.dataset.loop === 'true';
      this._video.addEventListener('play', () => this._onPlay(), options);
      this._video.addEventListener('pause', () => this._onPause(), options);
      this._video.addEventListener('ended', () => this._onEnded(), options);
      this._video.addEventListener('error', () => this._recover(true), options);
      for (const event of ['loadedmetadata', 'durationchange', 'timeupdate', 'emptied']) {
        this._video.addEventListener(event, () => this._syncTime(), options);
      }
      this._video.addEventListener('volumechange', () => this._syncMute(), options);
      this._video.addEventListener('webkitbeginfullscreen', () => {
        this._webkitFullscreen = true;
        this._syncFullscreen();
      }, options);
      this._video.addEventListener('webkitendfullscreen', () => {
        this._webkitFullscreen = false;
        this._syncFullscreen();
      }, options);
      this._button.addEventListener('click', () => this._start(), options);
      this._toggle.addEventListener('click', () => {
        if (this._video.paused) this._start();
        else this._pause();
      }, options);
      this._mute.addEventListener('click', () => {
        const silent = this._video.muted || this._video.volume === 0;
        this._video.muted = !silent;
        if (silent && this._video.volume === 0) this._video.volume = 1;
        this._syncMute();
        this._revealControls();
      }, options);
      this._fullscreen.addEventListener('click', () => this._toggleFullscreen(), options);
      this._seek.addEventListener('pointerdown', () => {
        this._seeking = true;
        this._revealControls();
      }, options);
      this._seek.addEventListener('input', () => this._seekToPosition(), options);
      this._seek.addEventListener('change', () => this._finishSeeking(), options);
      for (const event of ['pointerup', 'pointercancel']) {
        document.addEventListener(event, () => this._finishSeeking(), options);
      }
      for (const event of ['pointermove', 'pointerdown', 'pointerenter']) {
        this.addEventListener(event, () => this._revealControls(), options);
      }
      document.addEventListener('pointerdown', () => {
        this._keyboardMode = false;
        this._keyboardFocus = false;
        this._scheduleHide();
      }, { ...options, capture: true });
      document.addEventListener('keydown', () => { this._keyboardMode = true; }, { ...options, capture: true });
      this.addEventListener('keydown', () => {
        this._keyboardMode = true;
        this._keyboardFocus = true;
        this._revealControls();
      }, options);
      this.addEventListener('focusin', () => {
        this._keyboardFocus = this._keyboardMode;
        this._revealControls();
      }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this._events || this.contains(document.activeElement)) return;
          this._keyboardFocus = false;
          this._scheduleHide();
        });
      }, options);
      document.addEventListener('fullscreenchange', () => this._syncFullscreen(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this._pause();
      }, options);

      if (this.dataset.pauseOffscreen !== 'false' && 'IntersectionObserver' in window) {
        this._observer = new IntersectionObserver((entries) => {
          if (!this._isFullscreen() && entries.some((entry) => !entry.isIntersecting || entry.intersectionRatio < 0.15)) {
            this._pause();
          }
        }, { threshold: [0, 0.15] });
        this._observer.observe(this);
      }

      players.add(this);
      this._fullscreen.hidden = !((typeof this.requestFullscreen === 'function' && document.fullscreenEnabled !== false)
        || typeof this._video.webkitEnterFullscreen === 'function');
      if (this.dataset.seekLabel) this._seek.setAttribute('aria-label', this.dataset.seekLabel);
      this.setAttribute('data-ready', '');
      this._showPoster(this._playLabel);
      this._syncTime();
      this._syncMute();
      this._syncFullscreen();
    }

    disconnectedCallback() {
      this._pause();
      this._events?.abort();
      this._events = null;
      this._observer?.disconnect();
      this._observer = null;
      clearTimeout(this._hideTimer);
      this._hideTimer = null;
      this._pending = null;
      this._started = false;
      this._seeking = false;
      this._keyboardFocus = false;
      if (this._video) this._video.controls = true;
      if (this._button) this._button.hidden = true;
      if (this._controls) this._controls.hidden = true;
      players.delete(this);
      for (const attribute of ['data-ready', 'data-playing', 'data-paused', 'data-muted', 'data-fullscreen', 'data-controls-visible']) {
        this.removeAttribute(attribute);
      }
    }

    _claim() {
      owner = this;
      for (const player of players) {
        if (player !== this) player._pause();
      }
    }

    _pause() {
      if (owner === this) owner = null;
      this._video?.pause();
    }

    _start() {
      if (!this.isConnected || !this._video.paused) return;
      this._claim();
      const request = {};
      this._pending = request;

      if (this._video.error) this._video.load();
      let playback;
      try {
        playback = this._video.play();
      } catch (error) {
        this._recover(true);
        this._pending = null;
        return;
      }

      Promise.resolve(playback).then(() => {
        if (!this.isConnected || owner !== this) this._video.pause();
        if (this._pending === request) this._pending = null;
      }).catch((error) => {
        if (this._pending !== request) return;
        this._pending = null;
        if (owner === this) this._recover(error.name !== 'AbortError');
      });
    }

    _onPlay() {
      if (this._video.paused) return;
      if ((this._pending && owner !== this) || document.hidden || !this.isConnected) {
        this._pause();
        return;
      }

      this._claim();
      this._started = true;
      this._button.hidden = true;
      this._video.controls = false;
      this._toggle.setAttribute('aria-label', this.dataset.pauseLabel || this._playLabel);
      this.removeAttribute('data-paused');
      this.setAttribute('data-playing', '');
      this._revealControls();
    }

    _onPause() {
      if (!this.isConnected || !this._started || !this._video.paused || this._video.ended) return;
      if (owner === this) owner = null;
      this._video.controls = false;
      this._button.hidden = false;
      this._button.setAttribute('aria-label', this._playLabel);
      this._toggle.setAttribute('aria-label', this._playLabel);
      this.removeAttribute('data-playing');
      this.setAttribute('data-paused', '');
      this._revealControls();
    }

    _showPoster(label) {
      this._started = false;
      this._seeking = false;
      this._video.controls = false;
      this._button.hidden = false;
      this._button.setAttribute('aria-label', label);
      this._toggle.setAttribute('aria-label', this._playLabel);
      this._controls.hidden = true;
      clearTimeout(this._hideTimer);
      this._hideTimer = null;
      this.removeAttribute('data-playing');
      this.removeAttribute('data-paused');
      this.removeAttribute('data-controls-visible');
    }

    _onEnded() {
      this._pause();
      this._pending = null;
      this._showPoster(this.dataset.replayLabel || this._playLabel);
      this._video.load();
      this._syncTime();
    }

    _recover(failed) {
      this._pause();
      this._showPoster((failed && this.dataset.errorLabel) || this._playLabel);
    }

    _revealControls() {
      if (!this._started) return;
      this._controls.hidden = false;
      this.setAttribute('data-controls-visible', '');
      this._scheduleHide();
    }

    _scheduleHide() {
      clearTimeout(this._hideTimer);
      this._hideTimer = null;
      if (!this._started || this._video.paused || this._seeking || this._keyboardFocus) return;
      this._hideTimer = setTimeout(() => {
        this._hideTimer = null;
        if (!this._video.paused && !this._seeking && !this._keyboardFocus) this.removeAttribute('data-controls-visible');
      }, 2000);
    }

    _formatTime(value) {
      const seconds = Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
      const minutes = Math.floor(seconds / 60);
      return minutes >= 60
        ? `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`
        : `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
    }

    _syncTime() {
      const duration = this._video.duration;
      const valid = Number.isFinite(duration) && duration > 0;
      const current = Number.isFinite(this._video.currentTime) ? this._video.currentTime : 0;
      const progress = valid ? Math.min(100, Math.max(0, current / duration * 100)) : 0;
      this._seek.disabled = !valid;
      if (!this._seeking) this._seek.value = String(progress);
      this.style.setProperty('--feed-progress', `${this._seek.disabled ? 0 : this._seek.value}%`);
      this._current.textContent = this._formatTime(current);
      this._duration.textContent = this._formatTime(valid ? duration : 0);
      if (this.dataset.positionLabel) {
        this._seek.setAttribute('aria-valuetext', this.dataset.positionLabel
          .replace('__current__', this._current.textContent).replace('__duration__', this._duration.textContent));
      }
    }

    _seekToPosition() {
      const duration = this._video.duration;
      if (!Number.isFinite(duration) || duration <= 0) return;
      const value = Number(this._seek.value);
      if (!Number.isFinite(value)) return;
      try {
        this._video.currentTime = duration * Math.min(100, Math.max(0, value)) / 100;
      } catch (error) {
        this._seeking = false;
      }
      this._syncTime();
      this._revealControls();
    }

    _finishSeeking() {
      if (!this._seeking) return;
      this._seeking = false;
      this._syncTime();
      this._revealControls();
    }

    _syncMute() {
      const muted = this._video.muted || this._video.volume === 0;
      this.toggleAttribute('data-muted', muted);
      this._mute.setAttribute('aria-pressed', String(muted));
      const label = muted ? this.dataset.unmuteLabel : this.dataset.muteLabel;
      if (label) this._mute.setAttribute('aria-label', label);
    }

    _isFullscreen() {
      return Boolean(this._webkitFullscreen || this._video.webkitDisplayingFullscreen
        || (document.fullscreenElement && this.contains(document.fullscreenElement)));
    }

    _syncFullscreen() {
      const fullscreen = this._isFullscreen();
      this.toggleAttribute('data-fullscreen', fullscreen);
      this._fullscreen.setAttribute('aria-pressed', String(fullscreen));
      const label = fullscreen ? this.dataset.exitFullscreenLabel : this.dataset.fullscreenLabel;
      if (label) this._fullscreen.setAttribute('aria-label', label);
      this._revealControls();
    }

    async _toggleFullscreen() {
      try {
        if (this._isFullscreen()) {
          if (document.fullscreenElement && typeof document.exitFullscreen === 'function') await document.exitFullscreen();
          else if (typeof this._video.webkitExitFullscreen === 'function') this._video.webkitExitFullscreen();
        } else if (typeof this.requestFullscreen === 'function' && document.fullscreenEnabled !== false) {
          await this.requestFullscreen();
        } else if (typeof this._video.webkitEnterFullscreen === 'function') {
          this._video.webkitEnterFullscreen();
        }
      } catch (error) {
      }
      if (this._events) this._syncFullscreen();
    }
  }

  customElements.define('spottle-feed-video', SpottleFeedVideo);
})();


  } catch(e) { console.error(e); }
})();
})();
